module.exports = __webpack_public_path__ + "img/03.78d73b6a.png";